import { useNavigate } from 'react-router-dom';
import logouticon from '../../assets/images/logouticon.svg';
import Cookies from 'js-cookie';

const LogoutModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Add logout logic here (clear tokens, etc.)
    Cookies.remove('Admin_Token');
     Cookies.remove('AccessPermission');
    console.log('User logged out');
    navigate('/login');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#000000bf] p-4">
      <div className="bg-white rounded-2xl w-full max-w-[500px] pb-8 pt-3 px-13 shadow-[0_4px_31.9px_11px_rgba(255,255,255,0.25)] animate-fade-in">
        {/* Icon */}
        <div className="flex justify-center mb-0">
          <div className="">
            <img src={logouticon} alt="" className='w-[140px] mx-auto' />
          </div>
        </div>

        {/* Title */}
        <h2 className="md:text-3xl text-xl font-medium text-black text-center tracking-[0] leading-[normal] mb-3">
          Confirm Logout
        </h2>

        {/* Description */}
        <p className="text-xl font-normal text-textcolor text-center tracking-[0] leading-[24px] mb-8">
          Are you sure you want to logout?
        </p>

        {/* Buttons */}
        <div className="flex items-center gap-3">
          <button
            onClick={onClose}
            className="cursor-pointer flex-1 px-6 py-3 bg-white border-1 border-primary text-black font-medium text-base rounded-full hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleLogout}
            className="cursor-pointer flex-1 px-6 py-3 bg-primary hover:bg-hover text-white font-medium text-base rounded-full transition-colors"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
